const findIndexOfDocumentCountry = (selectedOptionsParam, country, document) => selectedOptionsParam
  .findIndex(
    (doc, idx) => country === doc.country
    && selectedOptionsParam[idx].documents.includes(document),
  );

export default findIndexOfDocumentCountry;
